import api from "../../utils/api";

function normalizeMember(raw) {
  return {
    id: raw.id,
    fullName: raw.full_name || "",
    email: raw.email || "",
    role: raw.role || "member",
    isOwner: Boolean(raw.is_owner),
    joinedAt: raw.joined_at || null,
  };
}

/** Owner + sub-users of the caller's company. */
export async function fetchTeam() {
  const data = await api.get("/api/users/team/", { auth: true });
  return {
    companyName: data.company_name || "",
    isOwner: Boolean(data.is_owner),
    owner: data.owner ? normalizeMember(data.owner) : null,
    members: (data.members || []).map(normalizeMember),
    memberCount: data.member_count ?? 0,
  };
}

/** Owner adds a sub-user with their own login. */
export async function createTeamMember({ fullName, email, password }) {
  const data = await api.post(
    "/api/users/team/",
    { full_name: fullName, email, password },
    { auth: true }
  );
  return normalizeMember(data);
}

export async function removeTeamMember(memberId) {
  return api.delete(`/api/users/team/${memberId}/`, { auth: true });
}
